import React, { useState } from 'react';
import {
  AppBar, Toolbar, Container, Box, Typography, Button, IconButton,
  Drawer, List, ListItemButton, ListItemText, Menu, MenuItem, useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const navItems = [
  {
    label: 'Invest',
    children: [
      { label: 'How It Works', to: '/how-it-works' },
      { label: 'Current Deals', to: '/deals' },
    ],
  },
  { label: 'Investors', to: '/investors' },
  { label: 'Entrepreneurs', to: '/entrepreneurs' },
  {
    label: 'About Us',
    children: [
      { label: 'Who We Are', to: '/about-us' },
      { label: 'Testimonials', to: '/testimonials' },
    ],
  },
  { label: 'Portfolio', to: '/startups' },
  { label: 'Research & Media', to: '/knowledge-center' },
  { label: 'Blog', to: '/blog' },
];

const MarketingHeader = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const handleMenuOpen = (e, label) => {
    setMenuAnchor(e.currentTarget);
    setActiveMenu(label);
  };
  const handleMenuClose = () => {
    setMenuAnchor(null);
    setActiveMenu(null);
  };

  return (
    <>
      <AppBar position="sticky" elevation={1} sx={{ backgroundColor: 'white', color: '#333' }}>
        <Container maxWidth="lg">
          <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
            {/* Logo */}
            <Typography
              component={Link}
              to="/"
              variant="h5"
              sx={{ fontWeight: 700, fontFamily: 'Georgia, serif', color: '#0a3d3d', textDecoration: 'none' }}
            >
              iAngels™
            </Typography>

            {/* Desktop nav */}
            {!isMobile && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {navItems.map((item) =>
                  item.children ? (
                    <Box key={item.label}>
                      <Button
                        onClick={(e) => handleMenuOpen(e, item.label)}
                        endIcon={<KeyboardArrowDownIcon />}
                        sx={{ color: '#333', textTransform: 'none', fontSize: '0.95rem' }}
                      >
                        {item.label}
                      </Button>
                      <Menu
                        anchorEl={menuAnchor}
                        open={activeMenu === item.label}
                        onClose={handleMenuClose}
                      >
                        {item.children.map((child) => (
                          <MenuItem
                            key={child.to}
                            onClick={() => { handleMenuClose(); navigate(child.to); }}
                          >
                            {child.label}
                          </MenuItem>
                        ))}
                      </Menu>
                    </Box>
                  ) : (
                    <Button
                      key={item.label}
                      component={Link}
                      to={item.to}
                      sx={{ color: '#333', textTransform: 'none', fontSize: '0.95rem' }}
                    >
                      {item.label}
                    </Button>
                  )
                )}
              </Box>
            )}

            {/* Right buttons */}
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              {!isMobile && (
                <>
                  <Button
                    component={Link}
                    to="/login"
                    variant="outlined"
                    sx={{ borderColor: '#0d9488', color: '#0d9488', textTransform: 'none' }}
                  >
                    Login
                  </Button>
                  <Button
                    component={Link}
                    to="/login?tab=register"
                    variant="contained"
                    sx={{ backgroundColor: '#0d9488', textTransform: 'none', '&:hover': { backgroundColor: '#0f766e' } }}
                  >
                    Sign Up
                  </Button>
                </>
              )}
              {isMobile && (
                <IconButton onClick={() => setDrawerOpen(true)}>
                  <MenuIcon />
                </IconButton>
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile drawer */}
      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box sx={{ width: 280, pt: 2 }}>
          <List>
            {navItems.flatMap((item) =>
              item.children
                ? item.children.map((child) => (
                    <ListItemButton key={child.to} component={Link} to={child.to} onClick={() => setDrawerOpen(false)}>
                      <ListItemText primary={child.label} />
                    </ListItemButton>
                  ))
                : [
                    <ListItemButton key={item.to} component={Link} to={item.to} onClick={() => setDrawerOpen(false)}>
                      <ListItemText primary={item.label} />
                    </ListItemButton>,
                  ]
            )}
            <ListItemButton component={Link} to="/login" onClick={() => setDrawerOpen(false)}>
              <ListItemText primary="Login" />
            </ListItemButton>
            <ListItemButton component={Link} to="/login?tab=register" onClick={() => setDrawerOpen(false)}>
              <ListItemText primary="Sign Up" sx={{ color: '#0d9488', fontWeight: 600 }} />
            </ListItemButton>
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default MarketingHeader;
